import React from "react";
import logo from "../assets/logo.ico";

const Footer = () => (
  <>
    <style>{`
      @keyframes ring {
        0%, 100% {
          transform: scale(1);
          opacity: 1;
        }
        50% {
          transform: scale(1.15);
          opacity: 0.8;
        }
      }

      @keyframes pulse {
        0%, 100% {
          opacity: 1;
        }
        50% {
          opacity: 0.7;
        }
      }

      .call-icon {
        animation: ring 1.5s ease-in-out infinite;
      }

      .call-icon-pulse {
        animation: pulse 2s ease-in-out infinite;
      }
    `}</style>

    <footer id="contact" className="bg-[#062B45] pt-16">
    <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16">
      {/* Brand */}
      <div>
        <img src={logo} alt="Heladoc logo" className="w-28 h-28 mb-4 object-contain" />
        <p className="text-sm text-white/50 leading-relaxed">
          HelaDoc is Sri Lanka’s premier AI-driven healthcare platform, 
          connecting patients with a vast network of doctors, pharmacies, and labs for seamless, intelligent care.
        </p>
      </div>

      {/* Quick Links */}
      <div>
        <h5 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">
          Quick Links
        </h5>
        <ul className="space-y-2">
          {[
            { label: "Home", id: "home" },
            { label: "About Us", id: "about" },
            { label: "Make an Appointment", id: "bookings" },
            { label: "Latest News", id: "news-achievements" },
            { label: "Contact", id: "contact" }
          ].map((link) => (
            <li key={link.id}>
              <a 
                href={`#${link.id}`} 
                className="text-sm text-white/55 hover:text-white hover:translate-x-1 transition-all duration-200"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Working Hours */}
      <div>
        <h5 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">
          Our Services
        </h5>
        <div className="text-sm text-white/50 space-y-1.5 leading-relaxed">
          <p>AI Mental Health Support</p>
          <p>Smart Dental Diagnostics</p>
          <p>3D Avatar Consultations</p>
          <p>Online Pharmacy & Labs</p>
          <p>Insurance Claims Tracking</p>
        </div>
      </div>

      {/* Contact */}
      <div>
        <h5 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">
          Our Location
        </h5>
        <div className="text-sm text-white/50 leading-relaxed mb-4">
          <p>Manel, Maha Kowana,</p>
          <p>Hindagolla, Kurunegala,</p>
          <p>Sri Lanka.</p>
          <br />
          <a href="mailto:admin@pahanmi.live" className="text-[#0D9DAD] hover:text-white transition-colors duration-200">
            admin@pahanmi.live
          </a>
          <br />
          <span>+94 71 978 0187</span>
        </div>
        <div className="bg-gradient-to-r from-[#1A7A7A] to-[#0D9DAD] rounded-xl p-4">
          <div className="flex items-center gap-3">
            <svg
              className="w-6 h-6 text-white flex-shrink-0 call-icon"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
            </svg>
            <div>
              <div className="text-base font-bold text-white call-icon-pulse">Emergency Hotline</div>
              <div className="font-playfair text-xl font-bold text-white">+94 71 978 0187</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom */}
    <div className="max-w-7xl mx-auto px-6 mt-12 py-5 border-t border-white/[0.08] flex flex-wrap justify-between items-center gap-3">
      <p className="text-xs text-white/30">© 2026 HelaDoc. All Rights Reserved..</p>
      <p className="text-xs text-white/30">
        Privacy Policy &nbsp;·&nbsp; Terms of Use
      </p>
    </div>
    </footer>
  </>
);

export default Footer;
